import React from "react";
import "./styles/Loader.css";
const Loader = () => {
 return (
  <div className="text-center">
   <div className="rotate-ring-container">
    <div className="rotate-ring">
     <img src="/favicon.png" alt="Loading" />
    </div>
   </div>
  </div>
 );
};

export default Loader;
